import React, { useState, useEffect } from 'react'; // <-- Importa useState y useEffect

// Estilos para el pop-up (agrega un estilo para el input)
const styles = {
  backdrop: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 1050,
  },
  dialog: {
    backgroundColor: 'white', borderRadius: '8px', padding: '20px 30px',
    width: '90%', maxWidth: '450px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)', textAlign: 'center',
  },
  header: {
    marginBottom: '15px', fontSize: '1.5rem', fontWeight: 'bold',
  },
  headerSuccess: { color: '#28a745' },
  headerError: { color: '#dc3545' },
  headerConfirm: { color: '#ffc107' },
  message: {
    marginBottom: '25px', fontSize: '1.1rem', color: '#333',
  },
  // --- NUEVO ESTILO PARA EL INPUT ---
  input: {
    width: '90%',
    padding: '10px',
    marginBottom: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '1rem',
    textAlign: 'center',
  },
  // --- FIN DEL NUEVO ESTILO ---
  actions: {
    display: 'flex', gap: '15px', justifyContent: 'center',
  },
  button: {
    padding: '10px 25px', border: 'none', borderRadius: '5px',
    cursor: 'pointer', color: 'white', fontSize: '1rem',
  },
};

const Dialog = ({ dialogConfig, close }) => {
  const [inputValue, setInputValue] = useState(''); // <-- Estado para el PIN
  const { isOpen, type, title, message, onConfirm } = dialogConfig;

  // Resetea el input cada vez que el diálogo se abre
  useEffect(() => {
    if (isOpen) {
      setInputValue('');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const isConfirm = type === 'confirm';
  const isConfirmWithPin = type === 'confirmWithPin'; // <-- Variable para el nuevo tipo
  const isPrompt = type === 'prompt'; // <-- NUEVO TIPO

  // Usa el color de 'confirm' también para 'confirmWithPin'
  const headerStyle = type === 'success' ? styles.headerSuccess :
                      type === 'error' ? styles.headerError : styles.headerConfirm;

  const handleConfirm = () => {
    // Si es con PIN, pasa el valor. Si no, solo ejecuta onConfirm.
    if (isConfirmWithPin || isPrompt) {
      onConfirm(inputValue); // <-- Pasa el PIN al callback
    } else {
      onConfirm();
    }
    close(); // Cierra el diálogo
  };

  return (
    <div style={styles.backdrop}>
      <div style={styles.dialog}>
        <h2 style={{ ...styles.header, ...headerStyle }}>{title}</h2>
        <p style={styles.message}>{message}</p>

        {/* --- INPUT DE PIN CONDICIONAL --- */}
        {(isConfirmWithPin || isPrompt) && (
          <input
            type={isConfirmWithPin ? "password" : "number"} // Password para PIN, Number para Precio
            style={styles.input}
            placeholder={isConfirmWithPin ? "Ingresa el PIN" : "Ingresa el monto $"}
            value={inputValue}
            autoFocus
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
          />
        )}
        {/* --- FIN DEL INPUT --- */}

        <div style={styles.actions}>
          {(isConfirm || isConfirmWithPin || isPrompt) && (
            <button style={{...styles.button, backgroundColor: '#6c757d'}} onClick={close}>
              Cancelar
            </button>
          )}
          <button
            style={{...styles.button, backgroundColor: headerStyle.color || '#007bff'}}
            onClick={(isConfirm || isConfirmWithPin || isPrompt) ? handleConfirm : close}
          >
            {(isConfirm || isConfirmWithPin || isPrompt) ? 'Confirmar' : 'Entendido'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;